import React  from "react";
import SingleProduct from "../../../shared-components/SingleProduct/SingleProduct";
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {Link, NavLink } from "react-router-dom";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function Profile() {
    AnimationFileLoader();

    return (
      <>

      {/* Author */}
    <div className="author-area sep-bottom">
        <div className="author-cover author-cover-edit" data-bg-img="/img/bg/author-cover.png">
            <span className="upload-btn">
                <img src="/img/icons/plus.svg" className="svg" alt=""/>
                <input type="file" accept="image/*"/>
            </span>
        </div>
        <div className="author-info">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 d-flex justify-content-center justify-content-lg-start">
                        {/* Profile */}
                        <div className="author-profile text-center text-white d-inline-block pb-2 pb-lg-4">
                            <div className="user-avatar">
                                <img src="/img/media/profile-avatar.png" alt=""/>
                                <span className="upload-btn">
                                    <img src="/img/icons/plus.svg" className="svg" alt=""/>
                                    <input type="file" accept="image/*" />
                                </span>
                            </div>

                            <h5 className="user_name text-white">AneftyPunks</h5>
                            <p>Joined December 2022</p>
                        </div>
                        {/* End Profile */}
                    </div>
                    <div className="col-lg-6">
                        <div
                            className="d-flex flex-wrap align-items-center mt-10 justify-content-center justify-content-lg-end mb-3 mb-lg-0">
                            {/* Copy Clipboard */}
                            <div className="copy-clipboard-wrap mr-10 mb-10">
                                <input className="form-control" id="get-link" type="text" value="69b9ebde0178k7O7&exportsw"
                                    readOnly/>

                                {/* Copy Button */}
                                <NavLink to="#" id="copy-link-btn">
                                    <img src="/img/icons/copy-icon.svg" alt="" className="svg"/>
                                </NavLink>
                                {/* End Copy Button */}
                            </div>
                            {/* End Copy Clipboard */}

                            {/* Share */}
                            <div className="dropdown mr-10 mb-10">
                                <button className="btn-circle style--two dropdown-toggle" data-bs-toggle="dropdown">
                                    <img src="/img/icons/share-grey.svg" alt="" className="svg"/>
                                </button>
                                <ul className="dropdown-menu">
                                    <li><NavLink className="dropdown-item"  to="https://www.facebook.com/"><img
                                                src="/img/icons/facebook.svg" alt=""/> Share on Facebook</NavLink>
                                    </li>
                                    <li><NavLink className="dropdown-item"  to="https://www.twitter.com/"><img
                                                src="/img/icons/twitter.svg" alt=""/> Share on Twitter</NavLink></li>
                                    <li><NavLink className="dropdown-item"  to="https://www.Instagram.com/"><img
                                                src="/img/icons/instagram.svg" alt=""/> Share on Instagram</NavLink>
                                    </li>
                                    <li><NavLink className="dropdown-item"  to="https://www.linkedin.com/"><img
                                                src="/img/icons/linkedin.svg" alt=""/> Share on Linkedin</NavLink>
                                    </li>
                                </ul>
                            </div>
                            {/* End Share */}

                            <NavLink to="explore.html" className="btn btn-border style--two fz-13 mr-10 mb-10">Follow</NavLink>

                            {/* Options */}
                            <div className="dropdown mb-10">
                                <button className="btn-circle style--two dropdown-toggle" data-bs-toggle="dropdown">
                                    <img src="/img/icons/option-icon.svg" alt="" className="svg"/>
                                </button>
                                <ul className="dropdown-menu">
                                    <li><NavLink className="dropdown-item"  to="#">Report</NavLink>
                                    </li>
                                </ul>
                            </div>
                            {/* End Options */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* End Author */}

    {/* Profile */}
    <section className="pt-120 pb-120">
        <div className="container">
            <div className="row mb-50">
                <div className="col-xl-9 order-1 order-xl-0">
                    {/* Tab Buttons */}
                    <ul className="nav tab-buttons justify-content-center justify-content-xl-start">
                        <li>
                            <button className="active select-rounded text-uppercase lg" data-bs-toggle="tab"
                                data-bs-target="#collected">Collected <span>3</span></button>
                        </li>
                        <li>
                            <button className="select-rounded text-uppercase lg" data-bs-toggle="tab"
                                data-bs-target="#created">Created <span>9</span></button>
                        </li>
                        <li>
                            <button className="select-rounded text-uppercase lg" data-bs-toggle="tab"
                                data-bs-target="#favorited">Favorited <span>6</span></button>
                        </li>
                        <li>
                            <button className="select-rounded text-uppercase lg" data-bs-toggle="tab"
                                data-bs-target="#hidden">Hidden <span>12</span></button>
                        </li>
                        <li>
                            <select className="select-rounded lg">
                                <option value="offers">Offers</option>
                                <option value="offers_received">Offers received</option>
                                <option value="offers_made">Offers made</option>
                            </select>
                        </li>
                    </ul>
                    {/* End Tab Buttons */}
                </div>
                <div className="col-xl-3 order-0 order-xl-1 mb-4 mb-xl-0">
                    {/* Search Form */}
                    <form className="search-form style--two" action="#">
                        <div className="form-group ms-auto me-auto me-xl-0 mw-100">
                            <input type="text" className="form-control mb-0" placeholder="Search item…"/>
                            <button type="submit">
                                <img src="/img/icons/search.svg" className="svg" alt=""/>
                            </button>
                        </div>
                    </form>
                    {/* End Search Form */}
                </div>
            </div>

            <div className="tab-content">
                <div className="tab-pane fade show active" id="collected">
                    <div className="row">
                    <div className="col-lg-4 col-md-6">
              {/* Single Product */}

              <SingleProduct
                classList="single-product mb-30"
                productName="Colorful Abstract Painting"
                productPrice="0.69  ETH"
                info="2 to 100"
              />
              {/* End Single Product */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Single Product */}

              <SingleProduct
                classList="single-product mb-30"
                productName="Liquid Forest Princess"
                productPrice="03.66  ETH"
                info="00 : 00 : 00 LEFT"
              />
              {/* End Single Product */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Single Product */}

              <SingleProduct
                classList="single-product mb-30"
                productName="Animal Girl Painting"
                productPrice="1.89  ETH"
                info="2 to 100"
              />
              {/* End Single Product */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Single Product */}

              <SingleProduct
                classList="single-product mb-30"
                productName="Animal Girl Painting"
                productPrice="3.99  ETH"
                info="2 to 100"
              />
              {/* End Single Product */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Single Product */}

              <SingleProduct
                classList="single-product mb-30"
                productName="Animal Girl Painting"
                productPrice="1.79  ETH"
                info="2 to 100"
              />
              {/* End Single Product */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Single Product */}

              <SingleProduct
                classList="single-product mb-30"
                productName="The Girl With The Firefly"
                productPrice="0.88  ETH"
                info="00 : 00 : 00 LEFT"
              />
              {/* End Single Product */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Single Product */}

              <SingleProduct
                classList="single-product mb-30"
                productName="Synthase On Modern Painting"
                productPrice="0.84  ETH"
                info="00 : 00 : 00 LEFT"
              />
              {/* End Single Product */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Single Product */}

              <SingleProduct
                classList="single-product mb-30"
                productName="Liquid Forest Princess"
                productPrice="0.89  ETH"
                info="2 to 100"
              />
              {/* End Single Product */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Single Product */}

              <SingleProduct
                classList="single-product mb-30"
                productName="Colorful Abstract Painting"
                productPrice="0.69  ETH"
                info="2 to 100"
              />
              {/* End Single Product */}
            </div>
            <div className="col-lg-12 d-flex justify-content-center mt-30">
              <NavLink to="#" className="btn">
                <img src="/img/icons/btn-loadmore.svg" alt="" className="svg" />{" "}
                Load More
              </NavLink>
            </div>
                    </div>
                </div>
                <div className="tab-pane fade" id="created">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product1.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Liquid Forest Princess</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>03.66 ETH</h6>

                                            <div className="countdown-wrap">
                                                <ul className="countdown">
                                                    <li>
                                                        <span className="hours">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="minutes">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="seconds">00</span>
                                                    </li>
                                                    <li className="text-uppercase ms-1">left</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share
                                                            on Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-sm btn-border">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product4.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Colorful Abstract Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.69 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product6.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Animal Girl Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>1.89 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product7.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Animal Girl Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>3.99 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product8.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Animal Girl Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>1.79 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product2.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>The Girl With The Firefly</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.88 ETH</h6>

                                            <div className="countdown-wrap">
                                                <ul className="countdown">
                                                    <li>
                                                        <span className="hours">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="minutes">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="seconds">00</span>
                                                    </li>
                                                    <li className="text-uppercase ms-1">left</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share
                                                            on Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product3.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Synthase On Modern Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.84 ETH</h6>

                                            <div className="countdown-wrap">
                                                <ul className="countdown">
                                                    <li>
                                                        <span className="hours">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="minutes">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="seconds">00</span>
                                                    </li>
                                                    <li className="text-uppercase ms-1">left</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share
                                                            on Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product5.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Liquid Forest Princess</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.89 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product17.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Colorful Abstract Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.69 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-12 d-flex justify-content-center mt-30">
                            <NavLink to="#" className="btn"><img src="/img/icons/btn-loadmore.svg" alt="" className="svg"/>
                                Load
                                More</NavLink>
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade" id="favorited">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product6.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Animal Girl Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>1.89 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product4.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Colorful Abstract Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.69 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product1.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Liquid Forest Princess</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>03.66 ETH</h6>

                                            <div className="countdown-wrap">
                                                <ul className="countdown">
                                                    <li>
                                                        <span className="hours">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="minutes">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="seconds">00</span>
                                                    </li>
                                                    <li className="text-uppercase ms-1">left</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share
                                                            on Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-sm btn-border">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product7.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Animal Girl Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>3.99 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product8.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Animal Girl Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>1.79 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product2.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>The Girl With The Firefly</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.88 ETH</h6>

                                            <div className="countdown-wrap">
                                                <ul className="countdown">
                                                    <li>
                                                        <span className="hours">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="minutes">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="seconds">00</span>
                                                    </li>
                                                    <li className="text-uppercase ms-1">left</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share
                                                            on Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product3.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Synthase On Modern Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.84 ETH</h6>

                                            <div className="countdown-wrap">
                                                <ul className="countdown">
                                                    <li>
                                                        <span className="hours">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="minutes">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="seconds">00</span>
                                                    </li>
                                                    <li className="text-uppercase ms-1">left</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share
                                                            on Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product5.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Liquid Forest Princess</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.89 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product17.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Colorful Abstract Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.69 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-12 d-flex justify-content-center mt-30">
                            <NavLink to="#" className="btn"><img src="/img/icons/btn-loadmore.svg" alt="" className="svg"/>
                                Load
                                More</NavLink>
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade" id="hidden">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product7.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Animal Girl Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>3.99 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product4.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Colorful Abstract Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.69 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product1.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Liquid Forest Princess</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>03.66 ETH</h6>

                                            <div className="countdown-wrap">
                                                <ul className="countdown">
                                                    <li>
                                                        <span className="hours">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="minutes">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="seconds">00</span>
                                                    </li>
                                                    <li className="text-uppercase ms-1">left</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share
                                                            on Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-sm btn-border">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product6.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Animal Girl Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>1.89 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product8.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Animal Girl Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>1.79 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product2.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>The Girl With The Firefly</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.88 ETH</h6>

                                            <div className="countdown-wrap">
                                                <ul className="countdown">
                                                    <li>
                                                        <span className="hours">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="minutes">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="seconds">00</span>
                                                    </li>
                                                    <li className="text-uppercase ms-1">left</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share
                                                            on Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product3.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Synthase On Modern Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.84 ETH</h6>

                                            <div className="countdown-wrap">
                                                <ul className="countdown">
                                                    <li>
                                                        <span className="hours">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="minutes">00</span>
                                                    </li>
                                                    <li className="ms-1 me-1"> : </li>
                                                    <li>
                                                        <span className="seconds">00</span>
                                                    </li>
                                                    <li className="text-uppercase ms-1">left</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share
                                                            on Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product5.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Liquid Forest Princess</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.89 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Single Product */}
                            <div className="single-product mb-30">
                                <img src="/img/product/product17.png" alt=""/>

                                {/* Product Content */}
                                <div className="product-content">
                                    <div className="product-top">
                                        <h5>Colorful Abstract Painting</h5>
                                        <div className="d-flex justify-content-between">
                                            <h6>0.69 ETH</h6>
                                            <h6>2 to 100</h6>
                                        </div>
                                    </div>

                                    <div className="product-bottom">
                                        {/* Button Group */}
                                        <div className="button-group">
                                            <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                                            <div className="dropdown mr-10">
                                                <button className="btn-circle btn-border dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <img src="/img/icons/share.svg" alt="" className="svg"/>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.facebook.com/"><img
                                                                src="/img/icons/facebook.svg" alt=""/> Share on
                                                            Facebook</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.twitter.com/"><img
                                                                src="/img/icons/twitter.svg" alt=""/> Share on
                                                            Twitter</NavLink>
                                                    </li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.Instagram.com/"><img
                                                                src="/img/icons/instagram.svg" alt=""/> Share on
                                                            Instagram</NavLink></li>
                                                    <li><NavLink className="dropdown-item" 
                                                            to="https://www.linkedin.com/"><img
                                                                src="/img/icons/linkedin.svg" alt=""/> Share on
                                                            Linkedin</NavLink></li>
                                                </ul>
                                            </div>

                                            <Link to="/pages/item-details" className="btn btn-border btn-sm">
                                                <img src="/img/icons/judge-icon.svg" alt="" className="svg"/>
                                                Place Bid
                                            </Link>
                                        </div>
                                        {/* End Button Group */}
                                    </div>
                                </div>
                                {/* End Product Content */}
                            </div>
                            {/* End Single Product */}
                        </div>
                        <div className="col-lg-12 d-flex justify-content-center mt-30">
                            <NavLink to="#" className="btn"><img src="/img/icons/btn-loadmore.svg" alt="" className="svg"/>
                                Load
                                More</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* End Profile */}

    </>
  );
}

export default Profile;
